// react
import React, { useContext } from 'react'
import { Link } from 'react-router-dom'

// Contexts
import AuthContext from '../../../utils/authProvider'

// ant design
import { Card, Button, Tag, Tooltip } from 'antd'

// operations
import { QUERY_ROLES } from '../../../operations/queries/roles'

// components
import Listing from '../../Listing'

const RoleList = () => {
  const Auth = useContext(AuthContext)
  const isSuperAdmin = Auth.hasRole('SUPER_ADMIN')
  const canAddRoles = Auth.hasPermission('ADD_ROLES')
  const extra = (
    <>
      {canAddRoles && (
        <Tooltip title='Add new role'>
          <Link to='../role/add'>
            <Button type='primary'>Add Role</Button>
          </Link>
        </Tooltip>
      )}
    </>
  )
  const canEditRoles = Auth.hasPermission('EDIT_ROLES')
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (value, record) => (
        <div>
          <div>
            {canEditRoles ? (
              <Link to={`../roles/${record.id}`}>{value}</Link>
            ) : (
              <>{value}</>
            )}
            &nbsp;
            {isSuperAdmin && record.hidden && <Tag color='orange'>Hidden</Tag>}
          </div>
          {isSuperAdmin && <div className='cellWithId'>{record.id}</div>}
        </div>
      )
    }
  ]

  return (
    <>
      <Listing
        query={QUERY_ROLES}
        columns={columns}
        dataKey='roles'
        render={table => {
          return (
            <>
              <div className='page-container'>
                <Card title='Roles' bordered={false} extra={extra}>
                  {table}
                </Card>
              </div>
            </>
          )
        }}
      />
    </>
  )
}

export default RoleList
